















import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import * as Sentry from "@sentry/browser";
import AuthStore from "@/store/auth.store";
// eslint-disable-next-line @typescript-eslint/camelcase
import jwt_decode from "jwt-decode";
import { authenticationService } from "@/services/authentication.service";
import InvoicesAnalyticsStore from "@/store/invoices-analytics.store";
import InvoiceVolumeAnalyticsStore from "@/store/invoice-volume-analytics.store";
import RecognitionAnalyticsStore from "@/store/recognition-analytics.store";
import { LaunchDarklyUser } from "@/models/launch-darkly-user";

@Component
export default class Home extends Vue {
  private authStore: AuthStore = getModule(AuthStore, this.$store);
  private invoicesAnalyticsStore: InvoicesAnalyticsStore = getModule(
    InvoicesAnalyticsStore,
    this.$store
  );
  private invoiceVolumeAnalyticsStore: InvoiceVolumeAnalyticsStore = getModule(
    InvoiceVolumeAnalyticsStore,
    this.$store
  );
  private recognitionAnalyticsStore: RecognitionAnalyticsStore = getModule(
    RecognitionAnalyticsStore,
    this.$store
  );
  private get userIsAuthenticated() {
    return this.authStore.getUserAuthenticationState;
  }
  private get user() {
    return this.authStore.getSignedInUser;
  }
  async created() {
    if (this.userIsAuthenticated === false) {
      // obtain query in URL, customer site, and ip address, and request JWT from ObsidianAPI
      const query = window.location.search;
      const customerSite = document.referrer;
      const apiToken = await authenticationService.requestApiTokenAsync(
        query,
        customerSite
      );
      if (apiToken === "unauthorized") {
        this.$router.push({ path: "/403" });
      } else {
        await this.authStore.updateAccessToken(apiToken);
        const customerSiteList = await authenticationService.loadSitesAsync();
        this.authStore.updateSites(customerSiteList);
        if (this.recognitionAnalyticsStore.getSelectedSite === "") {
          this.recognitionAnalyticsStore.updateSelectedSite(
            customerSiteList[0].value
          );
        }
        if (this.invoicesAnalyticsStore.getSelectedSite === "") {
          this.invoicesAnalyticsStore.updateSelectedSite(
            customerSiteList[0].value
          );
        }
        if (this.invoiceVolumeAnalyticsStore.getSelectedSite === "") {
          this.invoiceVolumeAnalyticsStore.updateSelectedSite(
            customerSiteList[0].value
          );
        }
        this.authStore.updateAuthState(true);
        // decode token and send user properties to LaunchDarkly
        const decodedToken: any = jwt_decode(apiToken);
        const launchDarklyUser: LaunchDarklyUser = {
          key: decodedToken.uid,
          name: decodedToken.uid,
          email: decodedToken.uid,
          custom: {
            groups: decodedToken.groups
          },
          anonymous: false
        };
        await this.$launchDarkly.identify(launchDarklyUser);
        this.authStore.updateLaunchDarklyUser(launchDarklyUser);
        // update Sentry scope in production
        if (process.env.NODE_ENV === "production") {
          Sentry.configureScope(function(scope: any) {
            scope.setUser({
              uid: decodedToken.uid,
              userGroups: decodedToken.groups
            });
          });
        }
      }
      this.$router.push("/recognition");
    }
  }
}
